import * as React from 'react'
import { MessagesMainConnected } from './MessagesMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const MessagesMainExamples = () => {
  return (
    <div className="MessagesMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <MessagesMainConnected taskId="1212" />
      </Provider>
    </div>
  )
}
